import { z } from 'zod';

/** Cabecera que el cliente envía en cada petición que cambia datos (POST, PUT, PATCH, DELETE). */
export const CSRF_HEADER = 'x-csrf-token';

/** Cuerpo de toda respuesta de error de la API. */
export const errorBodySchema = z.object({
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ErrorBody = z.infer<typeof errorBodySchema>;
